// Gating granular por recurso para perfis do portal da organizacao.
// Espelha o modelo da averbadora e do banco.
//
// A LISTA DE RECURSOS MUDOU DE CASA em 04/09/2026 (feature 009): vive em
// `@atlas/types/prefeitura-recursos`, porque a API passou a conferir permissao no
// SERVIDOR, e nao so' no menu. Enquanto a lista era daqui, o servidor nao tinha
// contra o que conferir, e `prefeitura_permissoes` era decoracao de interface.
//
// O que ficou neste arquivo e' o que so' o cliente faz: ler o claim do JWT e
// reconhecer qual preset um conjunto de permissoes representa. O vocabulario e a
// funcao de cobertura vem do pacote de tipos, para os dois lados decidirem igual.

import {
  PREFEITURA_PRESETS,
  permissaoCobre,
  type PrefeituraAreaLabel,
} from "@atlas/types";

export {
  PREFEITURA_RESOURCE_GROUPS,
  PREFEITURA_TODAS_PERMISSOES,
  PREFEITURA_PRESETS,
  ALIAS_PERMISSAO,
} from "@atlas/types";
export type { PrefeituraAreaLabel } from "@atlas/types";

/** `null`/vazio = login da organizacao (ve tudo); `"*"` = wildcard; alias de
 *  chave legada respeitado. Delega para o pacote de tipos — a mesma funcao que a
 *  API usa, para tela e servidor nunca divergirem. */
export function podeAcessar(permissoes: string[] | null | undefined, key: string): boolean {
  return permissaoCobre(permissoes, key);
}

/** Le o array de permissoes do sub-usuario do JWT (claim prefeitura_permissoes).
 *  Ausente = login da organizacao (retorna null = ve tudo). */
export function readPrefeituraPermissoesFromJwt(accessToken: string | null | undefined): string[] | null {
  if (!accessToken) return null;
  try {
    const parts = accessToken.split(".");
    if (parts.length !== 3) return null;
    const b64 = parts[1]!.replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
    const payload = JSON.parse(atob(padded));
    if (Array.isArray(payload.prefeitura_permissoes)) return payload.prefeitura_permissoes as string[];
    return null;
  } catch {
    return null;
  }
}

/**
 * A sessao esta presa na troca de senha?
 *
 * Quem decide de verdade e' a API: com a marca ligada, `requirePermissaoPref`
 * responde 403 `senha_temporaria_pendente` em toda rota do portal. Ler a claim
 * aqui so' serve para levar a pessoa a tela certa, em vez de mostrar um portal
 * onde nada carrega.
 */
export function readPrefeituraSenhaTemporariaFromJwt(accessToken: string | null | undefined): boolean {
  if (!accessToken) return false;
  try {
    const parts = accessToken.split(".");
    if (parts.length !== 3) return false;
    const b64 = parts[1]!.replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
    return JSON.parse(atob(padded)).prefeitura_senha_temporaria === true;
  } catch {
    return false;
  }
}

export function detectarPrefeituraPreset(permissoes: string[]): PrefeituraAreaLabel {
  const set = new Set(permissoes);
  for (const [nome, keys] of Object.entries(PREFEITURA_PRESETS) as [PrefeituraAreaLabel, string[]][]) {
    if (nome === "personalizado") continue;
    if (keys.length !== set.size) continue;
    if (keys.every((k) => set.has(k))) return nome;
  }
  return "personalizado";
}

export const PREFEITURA_PRESET_LABELS: { value: PrefeituraAreaLabel; label: string; descricao: string }[] = [
  { value: "gestor",        label: "Gestor",        descricao: "Acesso total ao portal (wildcard *)." },
  { value: "rh",            label: "RH",            descricao: "Servidores, convenios, contratos, comunicados, anuencia." },
  { value: "financeiro",    label: "Financeiro",    descricao: "Folhas, ADF, contratos, relatorios." },
  { value: "personalizado", label: "Personalizado", descricao: "Ponto de partida vazio — marque caixa a caixa." },
];
